// PROD
export const environment = {
  production: false,
  version: '2',
  response24ClientKey: '-LT75cDlOhB3sr6T3P7A',
  response24ER24RSKey: 'aQv6o5p3G4nQF6NQ2qh4',
  response24ARSKey: 'GNlsXNbZ54wcBJVDlwH4',
  bidvestMTNKey:'vIFZimxvJEVaVQA1YGHz',
  bidvestVodacomKey:'Yep8xaTtkuNGPCJEJdjw',
  bidvestPilotKey: 'vIFZimxvJEVaVQA1YGHz',
  fromEmail: 'tech@response24.co.za',
  apiKey: '443K-LK3k-33klio-344kii99',
  firebase: {
    apiKey: "AIzaSyD61TCt32aV4lWQIIMDciS7viBePwPbFXc",
    authDomain: "response24-sa-uat-87856.firebaseapp.com",
    databaseURL: "https://response24-sa-uat-87856.firebaseio.com",
    projectId: "response24-sa-uat-87856",
    storageBucket: "response24-sa-uat-87856.appspot.com",
    messagingSenderId: "987607650174",
    appId: "1:987607650174:web:ea4354f1bdba9f8a5c6d2f"
  },
  functionsUrl: 'https://us-central1-response24-sa-uat-87856.cloudfunctions.net',
  functionsUrlPlusGroup1: 'https://us-central1-response-24-plus---group-uat.cloudfunctions.net',
  functionsUrlPlusGroup2: null,
  functionsUrlPlusGroup3: null,
  hostedUrl: 'https://response24-sa-uat-87856.firebaseapp.com',
  hostedUrlNoHttp: 'response24-sa-uat-87856.firebaseapp.com',
  hostedUrlAdminPortal: '/admin/pgs',
  hostedUrlClientPortal: '/client/pgs',
  hostedUrlProviderPortal: '/provider/pgs',
  paymentGateway: {
    // PROD
    entityId: '8acda4c76bdb30c9016be67c304e5431',
    bearerAuthToken: 'OGFjZGE0Y2Q2YmRiMzBjODAxNmJlNjdiZTBlODUxOGJ8MnM4REZzTU1IeQ==',
    hostUrl: 'https://oppwa.com/'
  },
  teams: {
    systemAlerts: 'https://911grr.webhook.office.com/webhookb2/39b316f0-76ba-4292-a1ed-43263d895241@6c922770-0835-4d86-a077-1cede03ca624/IncomingWebhook/812b937964ed4bedbfc594cea7eb3af1/5355fc31-fb71-4e27-a0fb-f7638b29501a/V2uUyeUFSptt-E9Fuub0x37rXl-AaMs8Bh5JiZU4Td7Gc1',
    systemAlertsBidvest: 'https://911grr.webhook.office.com/webhookb2/39b316f0-76ba-4292-a1ed-43263d895241@6c922770-0835-4d86-a077-1cede03ca624/IncomingWebhook/812b937964ed4bedbfc594cea7eb3af1/5355fc31-fb71-4e27-a0fb-f7638b29501a/V2uUyeUFSptt-E9Fuub0x37rXl-AaMs8Bh5JiZU4Td7Gc1',
    systemLogsUrl: 'https://911grr.webhook.office.com/webhookb2/39b316f0-76ba-4292-a1ed-43263d895241@6c922770-0835-4d86-a077-1cede03ca624/IncomingWebhook/812b937964ed4bedbfc594cea7eb3af1/5355fc31-fb71-4e27-a0fb-f7638b29501a/V2uUyeUFSptt-E9Fuub0x37rXl-AaMs8Bh5JiZU4Td7Gc1',
    systemManagementUrl: 'https://911grr.webhook.office.com/webhookb2/39b316f0-76ba-4292-a1ed-43263d895241@6c922770-0835-4d86-a077-1cede03ca624/IncomingWebhook/812b937964ed4bedbfc594cea7eb3af1/5355fc31-fb71-4e27-a0fb-f7638b29501a/V2uUyeUFSptt-E9Fuub0x37rXl-AaMs8Bh5JiZU4Td7Gc1'
  },
  plusFirebaseFunctionsUrls: [
    { 'clientKey': '-LT75cDlOhB3sr6T3P7A', 'clientName': 'Response24', 'plusFunctionUrl': 'https://us-central1-response-24-plus---group-uat.cloudfunctions.net' },
    { 'clientKey': 'SJlmXZA79fXYOZTUmw09', 'clientName': 'Internal Testing', 'plusFunctionUrl': 'https://us-central1-response-24-plus---group-uat.cloudfunctions.net' }
  ]
};